module.exports = __webpack_public_path__ + "img/stahlgelaender.ea3113f0.webp";